export const boxTeamsText = 'Create your organisation and invite your team members to join you on Recrypt';

export const boxChestText =
  'Create additional teams, invite new members and build as many chests as you like to store unlimited secrets';
